'use client';

import React from 'react';
import Link from 'next/link';

export default function CTASection() {
    return (
        <section className="py-16 sm:py-24 bg-gradient-to-br from-violet-500 via-violet-600 to-violet-700 relative overflow-hidden">
            {/* Background decoration */}
            <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 left-1/4 w-64 sm:w-96 h-64 sm:h-96 bg-white rounded-full blur-3xl" />
                <div className="absolute bottom-0 right-1/4 w-64 sm:w-96 h-64 sm:h-96 bg-white rounded-full blur-3xl" />
            </div>

            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
                {/* Badge - hidden on very small screens */}
                <div className="hidden sm:inline-flex items-center gap-2 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full mb-8">
                    <span className="relative flex h-2 w-2">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                        <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-400"></span>
                    </span>
                    <span className="text-sm text-white font-medium">Start validating in 5 minutes</span>
                </div>

                <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold tracking-tight text-white leading-tight">
                    Stop guessing.<br />
                    Start knowing.
                </h2>

                <p className="mt-4 sm:mt-6 text-base sm:text-lg lg:text-xl text-violet-100 max-w-2xl mx-auto leading-relaxed">
                    Every day you spend building the wrong thing is a day wasted. Get real validation from real people before you invest months of effort.
                </p>

                <div className="mt-8 sm:mt-10">
                    <Link
                        href="/signup"
                        className="group w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 px-6 sm:px-8 py-3.5 sm:py-4 bg-white text-violet-700 font-bold text-base sm:text-lg rounded-2xl hover:bg-gray-50 transition-all shadow-2xl shadow-violet-900/30 hover:-translate-y-1"
                    >
                        Create Your Validation Page
                    </Link>
                </div>

                <div className="mt-6 sm:mt-8 flex flex-wrap items-center justify-center gap-4 sm:gap-8 text-violet-200">
                    <div className="flex items-center gap-1.5 sm:gap-2">
                        <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-xs sm:text-sm font-medium">Free to build</span>
                    </div>
                    <div className="flex items-center gap-1.5 sm:gap-2">
                        <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-xs sm:text-sm font-medium">5 minute setup</span>
                    </div>
                    <div className="flex items-center gap-1.5 sm:gap-2">
                        <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                        </svg>
                        <span className="text-xs sm:text-sm font-medium">No credit card</span>
                    </div>
                </div>
            </div>
        </section>
    );
}
